import React from 'react'
import PropTypes from 'prop-types'
import { dynamicDataAttribute, toOneString } from 'helpers/utils'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import { H2 } from 'components/common/Text/Text'
import { LazyDiv } from 'components/common/LazyHtml'

const BOTCareerDescriptionTeaser = ({ title, content, onClick }) =>
  <div>
    <Title { ...dynamicDataAttribute('careers-teaser-title', toOneString(title)) } headline noMargin>{ title }</Title>
    <Description data-html-block content={ content } onClick={ onClick } />
  </div>

BOTCareerDescriptionTeaser.propTypes = {
  content: PropTypes.string,
  onClick: PropTypes.func,
  title: PropTypes.string
}

export default BOTCareerDescriptionTeaser

const Title = styled(H2)`
  ${Mixin.font.GothamBold(28)}
  ${Media.mobile`
    ${Mixin.font.GothamBold(18)}
  `}
`

const Description = styled(LazyDiv)`
  ${Mixin.responsive('margin', '30px 0', '10px 0 20px')}
`
